export const ALL_GROUPS_OPTION = 'All';
